import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import Modal from "react-bootstrap/Modal";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import { BASE_URL } from "../../config/axios";
import { formatDate, formattedDateLong } from "../Date";
import ExpenseDetailsAdd from "../settings/model/Expense";
import { handleErrorToast, formatDateTime, formatCurrencyIndian, ViewRequestRemarksExpense, ViewRequestRemarksImprest, ViewRequestStatusExpense, ViewRequestStatusImprest, ViewRequestStatus, ViewDynamicApprovalStatus, ViewDynamicApprovalRemarks, ViewDynamicApprovalDates, formatRoundoff2D, CSSForSelect23vWWidth, CSSForSelect, CSSForSelect20vWWidth, CSSForSelect15vWWidth, ProgressModal, CSSForSelectModern, } from "../CustomFunctions";
import { ExpenseAdd } from "../settings/model/ExpenseAddbutton";
import { AddwithWhiteCircle, AddwithBlueCircle, CrosswithGreyCircle, DeleteDustbin, CheckGreen, DropdownArrow, CrosswithRedCircle } from '../AllSvg';
import { DownloadImprestBill, DownloadExpenseBill } from "../SiteManagement/BulkModals";
import { DynamicRequestLogTimeline } from "../settings/DynamicApprovalProcess/DynamicApprovalComponents";
import { AddImpresetBulkBilling, AddUpdateImprestDetails, DeleteImprestDetails, GetModalofImprestdetails } from "../Imprest Details/ImprestCRUD";
import Select, { components } from "react-select";
import { Wallet, Landmark, Receipt, ChevronUp, ChevronDown, Sparkles, Users, IndianRupee, CheckCircle, FileText, Eye, Trash2, X, AlertCircle, Loader, Briefcase, MapPin, Save, ReceiptIndianRupee, ReceiptIndianRupeeIcon } from 'lucide-react';
const ImprestAdd = ({ getImprest, imprestDetails, list }) => {
  const [show, setShow] = useState(false);
  const projectId = sessionStorage.getItem("sitemanagement_project")
  const company = sessionStorage.getItem("sitemanagement_project_sub_company")

  const [uploadProgress, setUploadProgress] = useState(0);
  const [showProgressModal, setShowProgressModal] = useState(false);

  const handleClose = () => {
    setFormData({
      date: "",
      emp_account_detail: sessionStorage.getItem("sitemanagement_emp_id"),
      project: projectId ? projectId : "null",
      stationary_item: "",
      electronic_item: "",
      grocery: "",
      other_name: "",
      imprestbank_details: "",
      account_holder_name: "",
      account_number: "",
      ifsc_code: "",
      pan_card: "",
      phone_number: "",
      other: "",
      no_of_days: "",
      remarks: "",
      imprest_open: false,
      bank_name: "",
      other_details: [],
      approval_stages_data: {},
      multiple_emp_account_detail: [],
    })
    setErrors({});
    setInputState({});
    setIsSubmitted(false);
    setemployeeIds([]);
    setShow(false)
  };
  const handleShow = () => {
    getFilterProjects()
    getImprestTypeFormat()
    setShow(true)
  };


  const [formData, setFormData] = useState({
    date: "",
    emp_account_detail: sessionStorage.getItem("sitemanagement_emp_id"),
    project: projectId ? projectId : "null",
    stationary_item: 0,
    electronic_item: 0,
    grocery: 0,
    other_name: "",
    other: "",
    no_of_days: "",
    bank_name: "",

    remarks: "",
    imprest_name: "",
    imprestbank_details: "",
    account_holder_name: "",
    account_number: "",
    ifsc_code: "",
    pan_card: "",
    phone_number: "",
    imprest_open: false,
    other_details: [],
    approval_stages_data: {},
    multiple_emp_account_detail: [],
  });

  //******************Valedation Start********************* */

  const [isSubmitted, setIsSubmitted] = useState(false);
  const [errors, setErrors] = useState({});
  const [inputState, setInputState] = useState({});

  const validateForm = () => {
    const newErrors = {};
    const requiredFields = [
      "project",
      "date",
      "no_of_days",
      "imprest_name",
    ];
    if (employeeIds.length === 0) {
      newErrors.employeeIds = `This is required field!`
    }
    if (formData.project === "null") {
      newErrors.project = `This is required field!`
    }
    requiredFields.forEach((field) => {
      if (!formData[field]) {
        newErrors[field] = ` ${field.charAt(0).toUpperCase() + field.slice(1)
          } is required !`;
      }
    });

    setErrors(newErrors);
    setIsSubmitted(true);

    return Object.keys(newErrors).length === 0;
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setInputState({
      ...inputState,
      [name]: value.trim() ? "green" : "",
    });

    setFormData({
      ...formData,
      [name]: value,
    });
  };


  const handleOtherInputChange = (index, e) => {
    const { name, value } = e.target;
    setFormData((prevFormData) => {
      const newOthers = [...prevFormData.other_details];
      newOthers[index] = {
        ...newOthers[index],
        [name]: value
      };
      return {
        ...prevFormData,
        other_details: newOthers
      };
    });
  };

  const handleAddOthers = () => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      other_details: [
        ...prevFormData.other_details,
        {
          other_name: "",
          amount: "",
          approved_other: 0,
          remaining_other: 0
        },
      ]
    }));
  };

  const handleRemoveOthers = (index) => {
    setFormData((prevFormData) => {
      const newOthers = [...prevFormData.other_details];
      newOthers.splice(index, 1);
      return {
        ...prevFormData,
        other_details: newOthers
      };
    });
  };

  //******************Valedation End*********************** */

  const [loading, setLoading] = useState(false); //loading logic
  const handleFormSubmit = async (e) => {
    e.preventDefault();

    const updatedFormData = {
      ...formData,
      person: formData.multipleperson?.length,
      imprest_open: false,
    };

    if (validateForm()) {
      setShowProgressModal(true);
      setLoading(true); //loading logic
      setUploadProgress(0);

      const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic

      let progress = 0;
      const interval = setInterval(() => {
        progress += 10;
        if (progress >= 100) {
          progress = 100;
          clearInterval(interval);
        }
        setUploadProgress(progress);
      }, 100);

      try {
        let res = await axios.post(
          `${BASE_URL}/siteproject/imprest/`,
          updatedFormData
        );

        if (res.status === 200 || res.status === 201) {
          await getImprest();
          clearInterval(interval);
          toast.dismiss(loadingToastId);
          toast.success("Imprest Request Added Successfully");
          handleClose()
        }
      } catch (err) {
        //toast Logic
        clearInterval(interval);
        setUploadProgress(0);
        if (err.response) {
          toast.dismiss(loadingToastId);
          const errorData = err.response.data;

          if (typeof errorData.error === 'string') {
            // Single error message
            toast.error(`Error: ${errorData.error}`);
          } else if (typeof errorData === 'object' && errorData !== null) {
            // Multiple error messages
            Object.entries(errorData).forEach(([field, messages]) => {
              messages.forEach(message => toast.error(`"${field}": ${message}`));
            });
          } else {
            toast.error('Error:- Failed to Process!');
          }
        } else {
          toast.error('Error processing your request.');
        }
      } finally {
        clearInterval(interval);
        setTimeout(() => {
          setShowProgressModal(false);
        }, 1500);
        setLoading(false); //loading logic
        toast.dismiss(loadingToastId);
      }
    }
  };

  const [employeeList, setEmployeeList] = useState([]);

  const [projectList, setProjectList] = useState([]);
  const [buffer, setBuffering] = useState(true); //buffering logic
  const getFilterProjects = async () => {
    setBuffering(true); //buffering logic // Start Buffering
    try {
      const res = await axios.get(
        sessionStorage.getItem('sitemanagement_role') === 'AuthorityEngineer' ?
          `${BASE_URL}/siteproject/projectfilterbyauthority_engineer/${sessionStorage.getItem('sitemanagement_emp_id')}/null/`
          : sessionStorage.getItem('sitemanagement_role') === 'DataEntryOperator' ?
            `${BASE_URL}/siteproject/projectfilterbycom_operator/${sessionStorage.getItem('sitemanagement_emp_id')}/null/`
            : `${BASE_URL}/siteproject/project/`
      );
      setProjectList(res.data);
    } catch (err) {
      handleErrorToast(err)
    } finally {
      setBuffering(false);// End Buffering
    }
  };

  const getEmployeebySite = async () => {
    try {
      const response = await axios.get(`${BASE_URL}/siteproject/employeebyfiltersss/${formData.project}/`);
      setEmployeeList(response.data);
    } catch (error) {
      console.error(error);

    }
  };

  const [imprestTypeFormat, setImprestTypeFormat] = useState([]);
  const getImprestTypeFormat = async () => {
    try {
      setBuffering(true);
      const res = await axios.get(`${BASE_URL}/siteproject/impresttypebysubcompany/${company}/`);

      const formattedFormatData = res.data.map(item => ({
        other_name: item.other_name || "",
        amount: item.amount || 0,
        approved_other: item.approved_other || 0,
      }));

      setFormData({
        ...formData,
        other_details: formattedFormatData,
      });

      setImprestTypeFormat(res.data);
    } catch (error) {
      console.error(error);
    } finally {
      setBuffering(false);
    }
  };


  useEffect(() => {
    if (show === true && formData.project !== "null") {
      getEmployeebySite();
    }
  }, [show, formData.project])

  const projectOptions = imprestDetails
    .sort((a, b) => a.siteproject_prcode - b.siteproject_prcode)
    .map(project => ({
      value: project.site_project,
      label: `${project.siteproject_prcode} - ${project.siteproject_name}`,
    }));



  const [employeeIds, setemployeeIds] = useState([]);


  const employeeOptions = employeeList
    .sort((a, b) => a.emp_code - b.emp_code)
    .map(emp => ({
      value: emp.id,
      label: `${emp.emp_code} - ${emp.name}`,
    }));

  const handleEmployeeOptions = (options) => {
    if (!options || options.length === 0) {
      setemployeeIds([]);
    } else {
      const ids = options.map(opt => opt.value);
      setemployeeIds(ids);
    }
  };

  const Option = (props) => (
    <components.Option {...props}>

      <label title="Star" class="star">
        <input id="star-checkbox" checked={props.isSelected}
          onChange={() => null} className="checkbox" type="checkbox" />
        <div className="svg-container">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="svg-outline"
            viewBox="0 0 24 24"
          >
            <path
              d="M12 2.5L9.45 8.5L3 9.06L7.725 13.39L6.25 19.82L12 16.5L17.75 19.82L16.275 13.39L21 9.06L14.55 8.5L12 2.5ZM12 4.75L14 9.33L18.7 9.75L15 13.07L16.18 17.75L12 15.16L7.82 17.75L9 13.07L5.3 9.75L10 9.33L12 4.75Z"
            ></path>
          </svg>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="svg-filled"
            viewBox="0 0 24 24"
          >
            <path
              d="M12 2.5L9.45 8.5L3 9.06L7.725 13.39L6.25 19.82L12 16.5L17.75 19.82L16.275 13.39L21 9.06L14.55 8.5L12 2.5Z"
            ></path>
          </svg>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            height="100"
            width="100"
            className="svg-celebrate"
          >
            <circle r="2" cy="50" cx="50" className="particle"></circle>
            <circle r="2" cy="50" cx="50" className="particle"></circle>
            <circle r="2" cy="50" cx="50" className="particle"></circle>
            <circle r="2" cy="50" cx="50" className="particle"></circle>
            <circle r="2" cy="50" cx="50" className="particle"></circle>
            <circle r="2" cy="50" cx="50" className="particle"></circle>
            <circle r="2" cy="50" cx="50" className="particle"></circle>
            <circle r="2" cy="50" cx="50" className="particle"></circle>
          </svg>
        </div>
      </label>
      {props.label}
    </components.Option>
  );



  const MenuList = (props) => {
    const { options, selectProps } = props;

    const filteredOptions = options.filter(
      (opt) => opt.label.toLowerCase() !== "other"
    );

    const selectedValues = selectProps.value?.map((i) => i.value) || [];
    const filteredValues = filteredOptions.map((i) => i.value);

    const isAllSelected = filteredValues.every((val) =>
      selectedValues.includes(val)
    );

    const handleToggle = () => {
      if (isAllSelected) {
        const preserveOther = selectProps.value?.filter(
          (i) => i.label.toLowerCase() === "other"
        ) || [];
        selectProps.onChange(preserveOther);
      } else {
        const preserveOther = selectProps.value?.filter(
          (i) => i.label.toLowerCase() === "other"
        ) || [];
        selectProps.onChange([...filteredOptions, ...preserveOther]);
      }
    };

    return (
      <components.MenuList {...props}>
        <button
          type="button"
          onClick={handleToggle}
          style={{
            width: "100%",
            padding: "6px 0",
            cursor: "pointer",
            fontWeight: "600",
            borderBottom: "1px solid #e3e3e3",
            background: "white"
          }}
        >
          {isAllSelected ? "Unselect All" : "Select All"}
        </button>

        {props.children}
      </components.MenuList>
    );
  };

  useEffect(() => {
    setemployeeIds([]);
  }, [formData.project]);


  useEffect(() => {
    if (employeeIds.length !== 0) {
      setFormData((prev) => ({
        ...prev,
        multiple_emp_account_detail: employeeIds
      }))
    }
  }, [employeeIds]);

  const role = sessionStorage.getItem("sitemanagement_role")

  const [imprestDetailss, setImprestDetailsss] = useState([]);

  useEffect(() => {

    const filterData = imprestDetails.filter(i => i.site_project === formData.project)
    setImprestDetailsss(filterData);
    setFormData((prev) => ({
      ...prev,
      imprestbank_details: filterData[0]?.id || "",
      account_holder_name: filterData[0]?.account_holder_name || "",
      account_number: filterData[0]?.account_number || "",
      ifsc_code: filterData[0]?.ifsc_code || "",
      pan_card: filterData[0]?.pan_card || "",
      phone_number: filterData[0]?.phone_number || "",
      bank_name: filterData[0]?.bank_name || "",
    }))

  }, [imprestDetails, formData.project])

  const totalExpense =
    Number(formData.stationary_item) +
    Number(formData.electronic_item) +
    Number(formData.grocery) +
    formData.other_details?.reduce((total, other) => total + Number(other.amount || 0), 0);

  return (
    <>
      <button title="Additional Imprest Request" className="btn-animated" onClick={handleShow}>
        <AddwithWhiteCircle /> Additional Imprest Request
      </button>

      {showProgressModal ? (
        <ProgressModal show={showProgressModal} progress={uploadProgress} usedFor="Add" />
      ) : (
        <Modal show={show} onHide={handleClose} dialogClassName="modern-project-modal" size="xl">
          <Modal.Header className="modern-modal-header">
            <div className="header-content">
              <div style={{ color: "white" }}>
                <Wallet size={24} />
              </div>
              <div>
                <Modal.Title>Add Imprest Request</Modal.Title>
                <p className="header-subtitle" style={{ color: "white" }}>Request an imprest advance for a site or project</p>
              </div>
            </div>
            <button className="close-btn" onClick={handleClose}>
              <X size={20} />
            </button>
          </Modal.Header>

          <Modal.Body className="modern-modal-body">
            <div className="form-section">
              <div className="section-title">
                <Briefcase size={18} />
                <h4>Request Details</h4>
              </div>

              <div className="form-grid">
                {!projectId && (
                  <div className="form-field">
                    <label><MapPin size={14} /> For Project<span className="required">*</span></label>
                    <Select
                      name="project"
                      options={projectOptions}
                      value={projectOptions?.find(opt => opt.value === formData.project) || null}
                      onChange={(selected) => {
                        setFormData({
                          ...formData,
                          project: selected ? selected.value : "null",
                        });
                      }}
                      placeholder="Select Project"
                      isSearchable
                      isClearable
                      styles={CSSForSelectModern}
                    />
                    {errors.project && <span className="error-message">{errors.project}</span>}
                  </div>
                )}

                {role === "SiteManagement" && (
                  <div className="form-field">
                    <label> Imprest Name<span className="required">*</span></label>
                    <input
                      type="text"
                      name="imprest_name"
                      placeholder="Imprest Name"
                      onChange={handleInputChange}
                      value={formData.imprest_name}
                      className={errors.imprest_name ? "error" : inputState.imprest_name ? "success" : ""}
                    />
                    {errors.imprest_name && <span className="error-message">{errors.imprest_name}</span>}
                  </div>
                )}

                <div className="form-field">
                  <label> Date<span className="required">*</span></label>
                  <input
                    type="date"
                    name="date"
                    onChange={handleInputChange}
                    value={formData.date}
                    className={errors.date ? "error" : inputState.date ? "success" : ""}
                  />
                  {errors.date && <span className="error-message">{errors.date}</span>}
                </div>

                {role !== "SiteManagement" && (
                  <div className="form-field">
                    <label> Imprest Name<span className="required">*</span></label>
                    <input
                      type="text"
                      name="imprest_name"
                      placeholder="Imprest Name"
                      onChange={handleInputChange}
                      value={formData.imprest_name}
                      className={errors.imprest_name ? "error" : inputState.imprest_name ? "success" : ""}
                    />
                    {errors.imprest_name && <span className="error-message">{errors.imprest_name}</span>}
                  </div>
                )}

                <div className="form-field">
                  <label><IndianRupee size={14} /> Total Expense<span className="required" style={{ fontSize: '10px' }}>(Auto)</span></label>
                  <input
                    type="number"
                    value={totalExpense}
                    readOnly
                    style={{ cursor: 'not-allowed' }}
                  />
                </div>
              </div>
            </div>

            <div className="form-section">
              <div className="section-title">
                <Wallet size={18} />
                <h4>Additional Expenses</h4>
              </div>

              <div className="form-grid">
                {formData.other_details.map((other, index) => (
                  <React.Fragment key={index}>
                    <div className="form-field">
                      <label style={{ justifyContent: 'space-between', display: 'flex', width: '100%' }}>
                        <span>Expense Name</span>
                        {index !== 0 && (
                          <button type="button" title="Remove" className="ub-file-remove" style={{ padding: '2px' }} onClick={() => handleRemoveOthers(index)}>
                            <X size={14} />
                          </button>
                        )}
                      </label>
                      <input
                        type="text"
                        name="other_name"
                        placeholder="Expense Name"
                        onChange={(e) => handleOtherInputChange(index, e)}
                        value={other.other_name}
                      />
                    </div>

                    <div className="form-field">
                      <label><IndianRupee size={14} /> {other.other_name ? `${other.other_name} Expenses` : 'Other Expenses'}</label>
                      <input
                        type="number"
                        name="amount"
                        placeholder="0"
                        min={0}
                        onWheel={(e) => e.target.blur()}
                        onChange={(e) => handleOtherInputChange(index, e)}
                        value={other.amount}
                      />
                    </div>
                  </React.Fragment>
                ))}
              </div>

              <button type="button" title="Add Expense" className="btn-secondaryy" style={{ marginTop: '10px' }} onClick={handleAddOthers}>
                <AddwithBlueCircle />
                Add Another Expense
              </button>
            </div>

            <div className="form-section">
              <div className="section-title">
                <Users size={18} />
                <h4>Persons Involved</h4>
              </div>

              <div className="form-field full-width">
                <label> Name Of Person<span className="required">{formData.project === "null" ? " (Select Project First)*" : "*"}</span></label>
                <Select
                  options={employeeOptions}
                  isMulti
                  closeMenuOnSelect={false}
                  hideSelectedOptions={false}
                  placeholder="Select Name"
                  onChange={handleEmployeeOptions}
                  value={employeeOptions.filter((opt) => employeeIds?.includes(opt.value))}
                  styles={CSSForSelectModern}
                />
                {errors.employeeIds && <span className="error-message">{errors.employeeIds}</span>}
              </div>

              <div className="form-grid">
                <div className="form-field">
                  <label><Users size={14} /> Number of Persons<span className="required" style={{ fontSize: '10px' }}>(Read-Only)</span></label>
                  <input
                    type="number"
                    placeholder="0"
                    readOnly
                    value={employeeIds.length}
                  />
                </div>

                <div className="form-field">
                  <label> Number of Days<span className="required">*</span></label>
                  <input
                    type="number"
                    placeholder="Days"
                    name="no_of_days"
                    min={0}
                    onWheel={(e) => e.target.blur()}
                    onChange={handleInputChange}
                    value={formData.no_of_days}
                    className={errors.no_of_days ? "error" : inputState.no_of_days ? "success" : ""}
                  />
                  {errors.no_of_days && <span className="error-message">{errors.no_of_days}</span>}
                </div>

                <div className="form-field full-width">
                  <label> Remarks</label>
                  <textarea
                    name="remarks"
                    placeholder="Remarks"
                    onChange={handleInputChange}
                    value={formData.remarks}
                    rows={2}
                    className={errors.remarks ? "error" : inputState.remarks ? "success" : ""}
                  />
                  {errors.remarks && <span className="error-message">{errors.remarks}</span>}
                </div>
              </div>
            </div>

            <div className="form-actions">
              <button type="button" className="btn-secondaryy" onClick={handleClose}>
                Cancel
              </button>
              <button type="button" className="btn-primaryy" onClick={handleFormSubmit} disabled={loading}>
                {loading ? <Loader size={18} className="spinning" /> : <Save size={18} />}
                <span>{loading ? 'Submitting...' : 'Submit'}</span>
              </button>
            </div>

            <p className="error-message" style={{ marginTop: '12px' }}>
              {isSubmitted && Object.keys(errors).length > 0 && (
                Object.keys(errors).length > 5 ? (
                  <span>Please fill all mandatory fields!</span>
                ) : (
                  Object.keys(errors).map((field) =>
                    field.charAt(0).toUpperCase() + field.slice(1)
                  ).join(', ') + ' are required!'
                )
              )}
            </p>

            <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
          </Modal.Body>
        </Modal>
      )}
    </>
  );
};


const ImprestModelDelete = ({ id, getImprest }) => {
  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);
  const [showProgressModal, setShowProgressModal] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const handleFormSubmitDelete = async (e) => {
    e.preventDefault();
    setShowProgressModal(true);
    setLoading(true);
    setUploadProgress(0);

    const loadingToastId = toast.loading("Loading: Please wait...");

    let progress = 0;
    const interval = setInterval(() => {
      progress += 10;
      if (progress >= 100) {
        progress = 100;
        clearInterval(interval);
      }
      setUploadProgress(progress);
    }, 100);

    try {
      let res = await axios.delete(`${BASE_URL}/siteproject/imprest/${id.id}/`);
      if (res.status === 200) {
        await getImprest();
        toast.dismiss(loadingToastId);
        toast.success("Imprest deleted successfully!");
        setShow(false);
      } else {
        alert(res);
      }
    } catch (err) {
      clearInterval(interval);
      setUploadProgress(0);
      if (err.response) {
        const errorData = err.response.data;
        if (typeof errorData.error === 'string') {
          toast.error(`Error: ${errorData.error}`);
        } else if (typeof errorData === 'object' && errorData !== null) {
          Object.entries(errorData).forEach(([field, messages]) => {
            messages?.forEach(message => toast.error(`"${field}": ${message}`));
          });
        } else {
          toast.error('Error:- Failed to Process!');
        }
      } else {
        toast.error('Error processing your request.');
      }
    } finally {
      clearInterval(interval);
      setTimeout(() => {
        setShowProgressModal(false);
      }, 1500);
      setLoading(false);
      toast.dismiss(loadingToastId);
    }
  };

  return (
    <>
      <button title="Delete Imprest Request" className="model-delete-button-modern" style={{ backgroundColor: "#00000075" }} onClick={handleShow}>
        <DeleteDustbin modernButton="true" />
      </button>

      {showProgressModal ? (
        <ProgressModal show={showProgressModal} progress={uploadProgress} usedFor="Delete" />
      ) : (
        <Modal show={show} onHide={handleClose} dialogClassName="modern-required-modal" centered>
          <Modal.Header className="modern-modal-header requirement-modal-header">
            <div className="header-content">
              <div className="requirement-header-icon">
                <Trash2 size={22} />
              </div>
              <div>
                <Modal.Title>Delete Imprest</Modal.Title>
                <p className="header-subtitle" style={{ color: "white" }}>
                  This action cannot be undone
                </p>
              </div>
            </div>
            <button className="close-btn" onClick={handleClose}>
              <X size={20} />
            </button>
          </Modal.Header>

          <Modal.Body className="modern-modal-body requirement-modal-body">
            <div className="requirement-mode-summary" style={{ marginBottom: '20px' }}>
              <AlertCircle size={16} />
              <span>
                Are you sure you want to delete this imprest request?
              </span>
            </div>

            <div className="submit-buttons" style={{ justifyContent: 'flex-end' }}>
              <button type="button" className="btn-secondaryy" onClick={handleClose} disabled={loading}>
                Cancel
              </button>
              <button
                type="button"
                className="btn-primaryy"
                style={{ background: "#dc3545", borderColor: "#dc3545" }}
                onClick={handleFormSubmitDelete}
                disabled={loading}
              >
                {loading ? <Loader size={18} className="spinning" /> : <Trash2 size={18} />}
                <span>{loading ? 'Deleting...' : 'Delete'}</span>
              </button>
            </div>

            <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
          </Modal.Body>
        </Modal>
      )}
    </>
  );
};

const ExpenseSubmit = ({ i, getExpansee, total }) => {
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => {
    getSpecificExpenses()
    setShow(true)
  };

  const [updatedlist, setExpenseDetails] = useState([]);
  const [sum, setSum] = useState("");
  const getSpecificExpenses = async () => {
    try {
      const res = await axios.get(
        `${BASE_URL}/siteproject/expensedetailsbyexpense/${i.id}/`
      );

      const summ = res.data.reduce(
        (acc, item) => acc + parseFloat(item.item_amount),
        0
      );
      setSum(summ);
      const uniqueDatesSet = new Set();
      res.data.forEach((item) => {
        uniqueDatesSet.add(item.date);
      });

      // console.log(uniqueDatesSet)
      setExpenseDetails(Array.from(uniqueDatesSet));
    } catch (err) { }
  };


  const handleFormSubmitPut = async (e) => {
    e.preventDefault();
    const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic

    try {
      let res = await axios.put(`${BASE_URL}/siteproject/expense/${i.id}/`, {
        utilized_amount: sum,
        remaining_amount: Number(total) - Number(sum),
        submit_for_approval: true,
        partially_change: false,
        authority_approval_status: "pending",
      });

      if (res.status === 200) {
        await getExpansee();
        // setShow(false);
      } else {
        alert(res);
      }
    } catch (err) {
      //toast Logic
      if (err.response) {
        toast.dismiss(loadingToastId);
        const errorData = err.response.data;

        if (typeof errorData.error === 'string') {
          // Single error message
          toast.error(`Error: ${errorData.error}`);
        } else if (typeof errorData === 'object' && errorData !== null) {
          // Multiple error messages
          Object.entries(errorData).forEach(([field, messages]) => {
            messages.forEach(message => toast.error(`"${field}": ${message}`));
          });
        } else {
          toast.error('Error:- Failed to Process!');
        }
      } else {
        toast.error('Error processing your request.');
      }
    } finally {
      toast.dismiss(loadingToastId);
    }
  };

  return (
    <>
      <button className="model-edit-button" title="Submit Expense for Approval" onClick={handleShow}>
        <CheckGreen />
      </button>
      <Modal show={show} onHide={handleClose} dialogClassName="request-leave width-40vw">
        <Modal.Body>
          <div className="parent-div">

            <div className="bdy-div">
              <h6 className="task-Tab-heading align-center font-weight500 font-size-heading">Confirm Expense Submission of "{i.name}" </h6>
              <div className="flex-row">
                <label htmlFor="date" className="form-labels font-weight500 announce-date font-weight400  font-size-heading">
                  Date :
                </label>
                <div className="form-labels announce-date font-size-heading">
                  {formattedDateLong(i.date)}
                </div>
              </div>

              <div className="flex-row">
                <label
                  htmlFor="project_name"
                  className="form-labels  font-weight500    announce-date font-weight400  font-size-heading"
                >
                  Expense against Imprest :
                </label>
                <div className="form-labels announce-date font-size-heading">
                  {i.project_name}
                </div>
              </div>

              {/* <hr className="line" /> */}
              <hr className="line" />
              <div className="children">
                <div>
                  <label htmlFor="fooding" className="form-labels  font-weight500    announce-date font-weight400  font-size-heading">
                    Utilized Amount
                  </label>
                  <p className="utilize   font-weight500   -amount align-center" style={{ color: "red" }}>
                    {sum}
                  </p>
                </div>

                <div>
                  <label htmlFor="fooding" className="form-labels  font-weight500    announce-date font-weight400  font-size-heading">
                    Remaining Amount
                  </label>
                  <p className="remaining-amount  font-weight500    align-center" style={{ color: "#2576bc" }}>
                    {Number(total) - Number(sum)}
                  </p>
                </div>
              </div>

              <div className="button-models">
                <button className="model-button model-button-cancel  font-weight500   " onClick={handleClose}>
                  Cancel
                </button>
                <button
                  type="submit"
                  className="model-button   font-weight500    model-button-leave  font-weight500    font-size-heading"
                  onClick={handleFormSubmitPut}
                >
                  Confirm
                </button>
              </div>

            </div>
          </div>
          <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />

        </Modal.Body>
      </Modal >
      <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
    </>
  );
};

const ExpensePartialSubmit = ({ i, getExpansee, total }) => {
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => {
    getSpecificExpenses()
    setShow(true)
  };
  console.log("i")
  console.log(i)

  const [updatedlist, setExpenseDetails] = useState([]);
  const [sum, setSum] = useState("");
  const getSpecificExpenses = async () => {
    try {
      const res = await axios.get(
        `${BASE_URL}/siteproject/expensedetailsbyexpense/${i.id}/`
      );

      const summ = res.data.reduce(
        (acc, item) => acc + parseFloat(item.bill_approved_amt),
        0
      );
      setSum(summ);
      const uniqueDatesSet = new Set();
      res.data.forEach((item) => {
        uniqueDatesSet.add(item.date);
      });

      // console.log(uniqueDatesSet)
      setExpenseDetails(Array.from(uniqueDatesSet));
    } catch (err) { }
  };


  const handleFormSubmitPut = async (e) => {
    e.preventDefault();
    const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic

    try {
      let res = await axios.put(`${BASE_URL}/siteproject/expense/${i.id}/`, {
        utilized_amount: sum,
        remaining_amount: Number(total) - Number(sum),
        submit_for_approval: true,
        partially_change: false,
        // authority_approval_status: "pending",

      });

      if (res.status === 200) {
        await getExpansee();
      } else {
        alert(res);
      }
    } catch (err) {
      //toast Logic
      if (err.response) {
        toast.dismiss(loadingToastId);
        const errorData = err.response.data;

        if (typeof errorData.error === 'string') {
          // Single error message
          toast.error(`Error: ${errorData.error}`);
        } else if (typeof errorData === 'object' && errorData !== null) {
          // Multiple error messages
          Object.entries(errorData).forEach(([field, messages]) => {
            messages.forEach(message => toast.error(`"${field}": ${message}`));
          });
        } else {
          toast.error('Error:- Failed to Process!');
        }
      } else {
        toast.error('Error processing your request.');
      }
    } finally {
      toast.dismiss(loadingToastId);
    }
  };

  return (
    <>
      <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
      <button className="model-edit-button" title="Partial Submit Expense" onClick={handleShow}>
        <CheckGreen />
      </button>
      <Modal show={show} onHide={handleClose} dialogClassName="request-leave width-40vw">
        <Modal.Body>
          <div className="parent-div">
            <div className="bdy-div">
              <h6 className="task-Tab-heading align-center font-weight500 font-size-heading">Confirm Expense Submission of "{i.name}" </h6>
              <div className="flex-row">
                <label htmlFor="date" className="form-labels font-weight500 announce-date font-weight400  font-size-heading">
                  Date :
                </label>
                <div className="form-labels announce-date font-size-heading">
                  {formattedDateLong(i.date)}
                </div>
              </div>
              <div className="flex-row">
                <label
                  htmlFor="project_name"
                  className="form-labels  font-weight500    announce-date font-weight400  font-size-heading"
                >
                  Expense against Imprest :
                </label>
                <div className="form-labels announce-date font-size-heading">
                  {i.project_name}
                </div>
              </div>
              <hr className="line" />
              <div className="children">
                <div>
                  <label htmlFor="fooding" className="form-labels  font-weight500    announce-date font-weight400  font-size-heading">
                    Utilized Amount
                  </label>
                  <p className="utilize   font-weight500   -amount align-center" style={{ color: "red" }}>
                    {sum}
                  </p>
                </div>
                <div>
                  <label htmlFor="fooding" className="form-labels  font-weight500    announce-date font-weight400  font-size-heading">
                    Remaining Amount
                  </label>
                  <p className="remaining-amount  font-weight500    align-center" style={{ color: "#2576bc" }}>
                    {Number(total) - Number(sum)}
                  </p>
                </div>
              </div>
              <div className="button-models">
                <button className="model-button model-button-cancel  font-weight500   " onClick={handleClose}>
                  Cancel
                </button>
                <button
                  type="submit"
                  className="model-button   font-weight500    model-button-leave  font-weight500    font-size-heading"
                  onClick={handleFormSubmitPut}
                >
                  Confirm
                </button>
              </div>
            </div>
          </div>
          <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
        </Modal.Body>
      </Modal >
    </>
  );
};
const ExpenseModelDelete = ({ id, getExpansee }) => {
  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);
  const [showProgressModal, setShowProgressModal] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const handleFormSubmitDelete = async (e) => {
    e.preventDefault();
    setShowProgressModal(true);
    setLoading(true);
    setUploadProgress(0);

    const loadingToastId = toast.loading("Loading: Please wait...");

    let progress = 0;
    const interval = setInterval(() => {
      progress += 10;
      if (progress >= 100) {
        progress = 100;
        clearInterval(interval);
      }
      setUploadProgress(progress);
    }, 100);

    try {
      let res = await axios.delete(`${BASE_URL}/siteproject/expense/${id.id}/`);
      if (res.status === 200) {
        try {
          let imp = await axios.put(`${BASE_URL}/siteproject/imprest/${id.imprest}/`, {
            imprest_open: true
          });
          if (imp.status === 200) {
            await getExpansee();
            clearInterval(interval);
            toast.dismiss(loadingToastId);
            toast.success("Expense Deleted Successfully");
            setShow(false);
          } else {
            clearInterval(interval);
            setUploadProgress(0);
            toast.error("Error opening imprest: " + imp.statusText);
          }
        } catch (error) {
          clearInterval(interval);
          setUploadProgress(0);
          toast.error("Error opening imprest: " + error.message);
        }
      }
    } catch (err) {
      clearInterval(interval);
      setUploadProgress(0);
      handleErrorToast(err)
    } finally {
      clearInterval(interval);
      setTimeout(() => {
        setShowProgressModal(false);
      }, 1500);
      setLoading(false);
      toast.dismiss(loadingToastId);
    }
  };

  return (
    <>
      <button title="Delete Expense" className="model-delete-button-modern actionn-icon" style={{ backgroundColor: "#00000075" }} onClick={handleShow}>
        <DeleteDustbin modernButton="true" />
      </button>

      {showProgressModal ? (
        <ProgressModal show={showProgressModal} progress={uploadProgress} usedFor="Delete" />
      ) : (
        <Modal show={show} onHide={handleClose} dialogClassName="modern-required-modal" centered>
          <Modal.Header className="modern-modal-header requirement-modal-header">
            <div className="header-content">
              <div className="requirement-header-icon">
                <Trash2 size={22} />
              </div>
              <div>
                <Modal.Title>Delete Expense</Modal.Title>
                <p className="header-subtitle" style={{ color: "white" }}>
                  This action cannot be undone
                </p>
              </div>
            </div>
            <button className="close-btn" onClick={handleClose}>
              <X size={20} />
            </button>
          </Modal.Header>

          <Modal.Body className="modern-modal-body requirement-modal-body">
            <div className="requirement-mode-summary" style={{ marginBottom: '20px' }}>
              <AlertCircle size={16} />
              <span>
                Are you sure you want to delete this expense request?
              </span>
            </div>

            <div className="submit-buttons" style={{ justifyContent: 'flex-end' }}>
              <button type="button" className="btn-secondaryy" onClick={handleClose} disabled={loading}>
                Cancel
              </button>
              <button
                type="button"
                className="btn-primaryy"
                style={{ background: "#dc3545", borderColor: "#dc3545" }}
                onClick={handleFormSubmitDelete}
                disabled={loading}
              >
                {loading ? <Loader size={18} className="spinning" /> : <Trash2 size={18} />}
                <span>{loading ? 'Deleting...' : 'Delete'}</span>
              </button>
            </div>

            <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
          </Modal.Body>
        </Modal>
      )}
    </>
  );
};
const Expenses = ({ toggleState, expensetogglemanagenet, setToggleState }) => {
  const [imprest, setImprest] = useState([]);
  const [buffer, setBuffering] = useState(true);
  const [projectId, setProjectId] = useState(sessionStorage.getItem("sitemanagement_project") || "null");
  const [projectIdExpense, setProjectIdExpense] = useState(sessionStorage.getItem("sitemanagement_project") || "null");
  const [projectIdDetails, setProjectIdDetails] = useState(sessionStorage.getItem("sitemanagement_project") || "null");
  const [expandedImprestRow, setExpandedImprestRow] = useState(null);
  const [expandedExpenseRow, setExpandedExpenseRow] = useState(null);
  const [expandedDetailRow, setExpandedDetailRow] = useState(null);

  const role = sessionStorage.getItem("sitemanagement_role");
  const employeeId = sessionStorage.getItem('sitemanagement_emp_id');

  const getImprest = async () => {
    setBuffering(true);
    try {
      const res = await axios.get(
        `${BASE_URL}/siteproject/imprestbyproject/${projectId}/${role === "AuthorityEngineer" ? employeeId : "null"}/${role === "DataEntryOperator" ? employeeId : "null"}/`
      );
      setImprest(res.data);
    } catch (err) {
      if (err.response) {
        const errorData = err.response.data;
        if (typeof errorData.error === 'string') {
          toast.error(`Error: ${errorData.error}`);
        } else if (typeof errorData === 'object' && errorData !== null) {
          Object.entries(errorData).forEach(([field, messages]) => {
            messages.forEach(message => toast.error(`"${field}": ${message}`));
          });
        } else {
          toast.error('Error:- Failed to Process!');
        }
      } else {
        toast.error('Error processing your request.');
      }
    } finally {
      setBuffering(false);
    }
  };

  useEffect(() => {
    getImprest();
  }, [projectId]);

  const [expansee, setexpansee] = useState([]);

  const getExpansee = async () => {
    setBuffering(true);
    try {
      const res = await axios.get(
        `${BASE_URL}/siteproject/expensebyproject/${projectIdExpense}/${role === "AuthorityEngineer" ? employeeId : "null"}/${role === "DataEntryOperator" ? employeeId : "null"}/`
      );
      setexpansee(res.data);
    } catch (err) {
      handleErrorToast(err);
    } finally {
      setBuffering(false);
    }
  };

  useEffect(() => {
    getExpansee();
  }, [projectIdExpense]);

  const [imprestDetails, setImprestDetails] = useState([]);

  const getImprestDetails = async () => {
    setBuffering(true);
    try {
      const res = await axios.get(
        `${BASE_URL}/siteproject/imprestbankfilter/${projectIdDetails}/${role === "AuthorityEngineer" ? employeeId : "null"}/${role === "DataEntryOperator" ? employeeId : "null"}/`
      );
      setImprestDetails(res.data);
    } catch (err) {
      handleErrorToast(err);
    } finally {
      setBuffering(false);
    }
  };

  useEffect(() => {
    getImprestDetails();
  }, [projectIdDetails]);

  const navigate = useNavigate();
  const currentUrl = window.location.href;
  const urlParts = currentUrl.split("/");
  const baseUrl = "/" + urlParts[3] + `/expenseSlip`;
  let opener = "profile";
  if (expensetogglemanagenet) opener = "request";
  const openExenseSlip = (i) => {
    navigate(baseUrl, { state: { i, opener } });
  };

  const tableRef = useRef(null);

  const toggleImprestRow = (index) => setExpandedImprestRow(expandedImprestRow === index ? null : index);
  const toggleExpenseRow = (index) => setExpandedExpenseRow(expandedExpenseRow === index ? null : index);
  const toggleDetailRow = (index) => setExpandedDetailRow(expandedDetailRow === index ? null : index);

  const tabs = [
    { id: 1, label: 'Imprest Requests', icon: Wallet, show: true },
    { id: 3, label: 'Imprest Details', icon: Landmark, show: role !== "SiteManagement" },
    { id: 2, label: 'Expense', icon: ReceiptIndianRupeeIcon, show: true },
  ];

  const getImprestTotal = (item) => {
    if (item.fixed_imprest_amount) return Number(item.fixed_imprest_amount);
    return (
      Number(item.stationary_item || 0) +
      Number(item.electronic_item || 0) +
      Number(item.grocery || 0) +
      (item.other_details?.reduce((total, other) => total + Number(other.amount || 0), 0) || 0)
    );
  };

  const getApprovedTotal = (item) => {
    return (
      Number(item.approved_stationary_item || 0) +
      Number(item.approved_project_imprest_monthly || 0) +
      Number(item.approved_electronic_item || 0) +
      Number(item.approved_grocery || 0) +
      (item?.other_details?.reduce((total, other) => total + Number(other.approved_other || 0), 0) || 0)
    );
  };

  return (
    <div className="progress-modern-container">
      {/* Modern Tabs */}
      <div className="modern-tabs-container" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <div className="tabs-scroll">
          {tabs.filter(t => t.show).map((tab) => {
            const Icon = tab.icon;
            return (
              <button
                key={tab.id}
                className={`modern-tab-btn ${toggleState === tab.id ? 'active' : ''}`}
                onClick={() => setToggleState(tab.id)}
              >
                <Icon size={16} />
                <span>{tab.label}</span>
                {toggleState === tab.id && <div className="active-indicator" />}
              </button>
            );
          })}
        </div>

        <div style={{ display: 'flex', gap: '8px', paddingRight: '8px' }}>
          {toggleState === 2 && (
            <ExpenseAdd getExpansee={getExpansee} imprest={imprest} getimprest={getImprest} imprestDetails={imprestDetails} />
          )}
          {toggleState === 3 && (
            <AddUpdateImprestDetails usedfor="Add" getData={getImprestDetails} projectLists={imprestDetails} />
          )}
        </div>
      </div>

      {/* Tab 1: Imprest Requests actions */}
      {toggleState === 1 && (
        <div className="stats-minimal-row" style={{ justifyContent: 'space-between', flexWrap: 'wrap', gap: '10px' }}>
          <div className="stat-minimal-item">
            <Wallet size={14} />
            <span>Showing</span>
            <strong>{imprest.length} requests</strong>
          </div>
          <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
            <ImprestAdd getImprest={getImprest} imprestDetails={imprestDetails} />
            {role !== "SiteManagement" && (
              <AddImpresetBulkBilling imprestDetails={imprestDetails} getData={getImprest} list={imprest} />
            )}
            <DownloadImprestBill projectList={imprest} />
            {role === "SiteManagement" && imprestDetails?.length > 0 && (
              <GetModalofImprestdetails imprestDetails={imprestDetails} getData={getImprestDetails} buffer={buffer} />
            )}
          </div>

        </div>
      )}

      {toggleState === 2 && (
        <div className="stats-minimal-row">
          <div className="stat-minimal-item">
            <ReceiptIndianRupee size={14} />
            <span>Showing</span>
            <strong>{expansee.length} expenses</strong>
          </div>
        </div>
      )}

      {toggleState === 3 && (
        <div className="stats-minimal-row">
          <div className="stat-minimal-item">
            <Landmark size={14} />
            <span>Showing details of</span>
            <strong>{imprestDetails.length} projects</strong>
          </div>
        </div>
      )}

      {/* Tab 1 Table: Imprest Requests */}
      {toggleState === 1 && (
        <div className="table-wrapper-minimal table-box scroll-container-table">
          {buffer ? (
            <div className="loader-minimal"><div className="spinner-minimal"></div></div>
          ) : (
            <table className="progress-table-minimal" ref={tableRef}>
              <thead className="table-heading">
                <tr>
                  <th className="col-sno" style={{ width: '5%' }}>#</th>
                  <th className="col-period" style={{ width: '18%' }}>Imprest / Bank Details</th>
                  <th className="col-submitted text-center" style={{ width: '15%' }}>Proposed Amount</th>
                  <th className="col-approved text-center" style={{ width: '15%' }}>Approved Amount</th>
                  <th className="col-status text-center" style={{ width: '12%' }}>Status</th>
                  <th className="col-action text-center" style={{ width: '10%' }}>Action</th>
                </tr>
              </thead>
              <tbody>
                {imprest?.map((item, index) => {
                  const isExpanded = expandedImprestRow === index;
                  const proposedTotal = getImprestTotal(item);
                  const approvedTotal = getApprovedTotal(item);

                  return (
                    <React.Fragment key={index}>
                      <tr className="progress-row">
                        <td className="col-sno text-start">{index + 1}.</td>
                        <td className="col-period">
                          <button className="period-trigger" style={{ width: "100%" }} onClick={() => toggleImprestRow(index)}>
                            <Wallet size={12} />
                            <span>{item.imprest_name}</span>
                            {isExpanded ? <ChevronUp size={12} /> : <ChevronDown size={12} />}
                          </button>
                          <div style={{ fontSize: '10px', color: '#94a3b8', marginTop: '4px', paddingLeft: '4px' }}>
                            {formatDate(item.date)} • {item.bank_name || "-"}
                          </div>
                        </td>
                        <td className="col-submitted text-center">
                          <span className="badge-value">₹{formatCurrencyIndian(proposedTotal)}</span>
                        </td>
                        <td className="col-approved text-center">
                          <span className="badge-value">₹{formatCurrencyIndian(approvedTotal)}</span>
                        </td>
                        <td className="col-status text-center">
                          {item.dynamic_approval.length > 0 ? (
                            <ViewDynamicApprovalStatus dynamic_approval={item.dynamic_approval} />
                          ) : (
                            <ViewRequestStatusImprest i={item} approval_stages_data={item?.approval_stages_data} />
                          )}
                        </td>
                        <td className="col-action text-center">
                          <div className="action-group-minimal" style={{ justifyContent: 'center' }}>
                            {(item.dynamic_approval.every(da => da.approval_status === "pending") || item.dynamic_approval[0]?.approval_status === "rejected") ? (
                              role !== "SiteManagement" && (
                                <ImprestModelDelete getImprest={getImprest} id={item} />
                              )
                            ) : item.dynamic_approval[item.dynamic_approval.length - 1]?.approval_status === "approved" ? (
                              <span style={{ fontSize: '11px', color: '#059669', fontWeight: 600 }}>Completed</span>
                            ) : item.dynamic_approval.some(da => da.approval_status === "rejected") ? (
                              <span style={{ fontSize: '11px', color: '#ef4444', fontWeight: 600 }}>Terminated</span>
                            ) : (
                              <span style={{ fontSize: '11px', color: '#f59e0b', fontWeight: 600 }}>In Process</span>
                            )}
                          </div>
                        </td>
                      </tr>

                      {isExpanded && (
                        <tr className="expanded-row">
                          <td colSpan={6}>
                            <div className="expanded-content-attractive">
                              <div className="expanded-content-header">
                                <div className="expanded-content-title">
                                  <Sparkles size={13} />
                                  <span>Full Imprest Details</span>
                                </div>
                              </div>

                              <div style={{ display: 'flex', gap: '14px', flexWrap: 'wrap', marginBottom: '14px' }}>
                                <div className="stage-card submitted" style={{ flex: 1, minWidth: '240px' }}>
                                  <div className="stage-header">
                                    <Landmark size={14} />
                                    <span>Bank Details</span>
                                  </div>
                                  <div className="stage-content">
                                    <div className="stage-row"><span className="stage-label">Bank Name</span><span className="amount">{item.bank_name || "-"}</span></div>
                                    <div className="stage-row"><span className="stage-label">Account Number</span><span className="amount">{item.account_number || "-"}</span></div>
                                    <div className="stage-row"><span className="stage-label">IFSC Code</span><span className="amount">{item.ifsc_code || "-"}</span></div>
                                    <div className="stage-row"><span className="stage-label">PAN No.</span><span className="amount">{item.pan_card || "-"}</span></div>
                                    <div className="stage-row"><span className="stage-label">Holder Name</span><span className="amount">{item.account_holder_name || "-"}</span></div>
                                    <div className="stage-row"><span className="stage-label">Phone No.</span><span className="amount">{item.phone_number || "-"}</span></div>
                                  </div>
                                </div>

                                <div className="stage-card recommended" style={{ flex: 1, minWidth: '240px' }}>
                                  <div className="stage-header">
                                    <Users size={14} />
                                    <span>Persons & Timeline</span>
                                  </div>
                                  <div className="stage-content">
                                    <div className="stage-row"><span className="stage-label">No. of Persons</span><span className="amount">{item.multiple_emp_account_detail.length || item.total_number_of_Office_staff}</span></div>
                                    <div className="stage-row"><span className="stage-label">Days</span><span className="amount">{item.no_of_days}</span></div>
                                  </div>
                                  <div style={{ padding: '0 12px 10px' }}>
                                    <DynamicRequestLogTimeline i={item} detailedCheckKeys={['other_details', 'dynamic_approval']} />
                                  </div>
                                </div>

                                <div className="stage-card approved" style={{ flex: 1, minWidth: '240px' }}>
                                  <div className="stage-header">
                                    <IndianRupee size={14} />
                                    <span>Proposed Breakdown</span>
                                  </div>
                                  <div className="stage-content">
                                    {item.fixed_imprest_amount ? (
                                      <div className="stage-row"><span className="stage-label">Site Imprest Amount</span><span className="amount">₹{formatCurrencyIndian(item.fixed_imprest_amount)}</span></div>
                                    ) : (
                                      [
                                        { name: 'Stationary', value: item.stationary_item },
                                        { name: 'Electronics', value: item.electronic_item },
                                        { name: 'Grocery', value: item.grocery }
                                      ].map(({ name, value }) => Number(value) !== 0 && (
                                        <div className="stage-row" key={name}><span className="stage-label">{name}</span><span className="amount">₹{formatCurrencyIndian(value)}</span></div>
                                      ))
                                    )}
                                    {item.other_details?.map((other, idx) => (
                                      <div className="stage-row" key={other.other_name || `other-${idx}`}>
                                        <span className="stage-label">{other.other_name || `Other-${idx + 1}`}</span>
                                        <span className="amount">₹{formatCurrencyIndian(Number(other.amount) || 0)}</span>
                                      </div>
                                    ))}
                                    <div className="stage-row" style={{ fontWeight: 700 }}><span className="stage-label">Total</span><span className="amount">₹{formatCurrencyIndian(proposedTotal)}</span></div>
                                  </div>
                                </div>

                                <div className="stage-card" style={{ flex: 1, minWidth: '240px', background: 'white' }}>
                                  <div className="stage-header">
                                    <CheckCircle size={14} />
                                    <span>Approved Breakdown</span>
                                  </div>
                                  <div className="stage-content">
                                    {item.approved_project_imprest_monthly ? (
                                      <div className="stage-row"><span className="stage-label">Site Imprest Amount</span><span className="amount">₹{formatCurrencyIndian(item.approved_project_imprest_monthly)}</span></div>
                                    ) : (
                                      [
                                        { name: 'Approved Stationary', value: item.approved_stationary_item, proposed: item.stationary_item },
                                        { name: 'Approved Electronics', value: item.approved_electronic_item, proposed: item.electronic_item },
                                        { name: 'Approved Grocery', value: item.approved_grocery, proposed: item.grocery }
                                      ].map(({ name, value, proposed }) => Number(proposed) !== 0 && (
                                        <div className="stage-row" key={name}><span className="stage-label">{name}</span><span className="amount">₹{formatCurrencyIndian(value)}</span></div>
                                      ))
                                    )}
                                    {item.other_details?.map((other, idx) => (
                                      <div className="stage-row" key={other.other_name || `other-${idx}`}>
                                        <span className="stage-label">{other.other_name || `Other-${idx + 1}`}</span>
                                        <span className="amount">₹{formatCurrencyIndian(other.approved_other || 0)}</span>
                                      </div>
                                    ))}
                                    <div className="stage-row" style={{ fontWeight: 700 }}><span className="stage-label">Total</span><span className="amount">₹{formatCurrencyIndian(approvedTotal)}</span></div>
                                  </div>
                                </div>
                              </div>

                              <div className="stage-card" style={{ background: 'white' }}>
                                <div className="stage-header">
                                  <FileText size={14} />
                                  <span>Remarks</span>
                                </div>
                                <div className="stage-content">
                                  {item.dynamic_approval.length > 0 ? (
                                    <ViewDynamicApprovalRemarks dynamic_approval={item.dynamic_approval} />
                                  ) : (
                                    <ViewRequestRemarksImprest i={item} table="vehicle" approval_stages_data={item?.approval_stages_data} />
                                  )}
                                </div>
                              </div>

                              {item.dynamic_approval[item.dynamic_approval.length - 1]?.approval_status === "approved" && (
                                <div style={{ marginTop: '12px', padding: '10px 14px', background: '#f0fdf4', borderRadius: '10px', fontSize: '12px', color: '#166534' }}>
                                  <strong>Transaction Id:</strong> {item.account_approved_final_details || "No Transaction Id"}
                                  {item.account_transaction_proof && (
                                    <> • <a href={item.account_transaction_proof} target="blank" style={{ color: '#059669', fontWeight: 600 }}>View Proof</a></>
                                  )}
                                </div>
                              )}
                            </div>
                          </td>
                        </tr>
                      )}
                    </React.Fragment>
                  );
                })}
                {imprest?.length === 0 && (
                  <tr>
                    <td colSpan={6}>
                      <div className="empty-state-attractive">
                        <div className="empty-state-icon-wrap"><Wallet size={32} /></div>
                        <h4 className="empty-state-title">No Imprest Requests Found</h4>
                        <p className="empty-state-subtitle">No imprest requests have been made yet.</p>
                      </div>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          )}
        </div>
      )}

      {/* Tab 2 Table: Expense */}
      {toggleState === 2 && (
        <div className="table-wrapper-minimal table-box scroll-container-table">
          {buffer ? (
            <div className="loader-minimal"><div className="spinner-minimal"></div></div>
          ) : (
            <table className="progress-table-minimal">
              <thead className="table-heading">
                <tr>
                  <th className="col-sno" style={{ width: '5%' }}>#</th>
                  <th className="col-period" style={{ width: '20%' }}>Expense / Against Imprest</th>
                  <th className="col-submitted text-center" style={{ width: '15%' }}>Approved Amount</th>
                  <th className="col-approved text-center" style={{ width: '15%' }}>Spent Money</th>
                  <th className="col-status text-center" style={{ width: '12%' }}>Status</th>
                  <th className="col-action text-center" style={{ width: '10%' }}>Action</th>
                </tr>
              </thead>
              <tbody>
                {expansee.map((item, index) => {
                  const isExpanded = expandedExpenseRow === index;
                  const totalApprovedAmount =
                    Number(item.imprest_data?.approved_stationary_item || 0) +
                    Number(item.imprest_data?.approved_project_imprest_monthly || 0) +
                    Number(item.imprest_data?.approved_electronic_item || 0) +
                    Number(item.imprest_data?.approved_grocery || 0) +
                    (item.imprest_data?.other_details?.reduce((sum, other) => sum + Number(other.approved_other || 0), 0) || 0);

                  return (
                    <React.Fragment key={index}>
                      <tr className="progress-row">
                        <td className="col-sno text-start">{index + 1}.</td>
                        <td className="col-period">
                          <button className="period-trigger" style={{ width: "100%" }} onClick={() => toggleExpenseRow(index)}>
                            <Receipt size={12} />
                            <span>{item.name}</span>
                            {isExpanded ? <ChevronUp size={12} /> : <ChevronDown size={12} />}
                          </button>
                          <div style={{ fontSize: '10px', color: '#94a3b8', marginTop: '4px', paddingLeft: '4px' }}>
                            {formatDate(item.date)} • Against: {item.imprest_data?.imprest_name} ({item.imprest_data?.project_short_name})
                          </div>
                        </td>
                        <td className="col-submitted text-center">
                          <span className="badge-value">₹{formatCurrencyIndian(totalApprovedAmount)}</span>
                        </td>
                        <td className="col-approved text-center">
                          {item.submit_for_approval === false ? (
                            <span style={{ fontSize: '11px', color: '#f59e0b', fontWeight: 600 }}>Not Submitted</span>
                          ) : (
                            <>
                              <div className="progress-badge">
                                <span className="badge-label">Utilized</span>
                                <span className="badge-value">{item.utilized_amount ? formatRoundoff2D(item.utilized_amount) : '-'}</span>
                              </div>
                              <div className="progress-badge approved">
                                <span className="badge-label">Remaining</span>
                                <span className="badge-value">{item.remaining_amount ? formatRoundoff2D(item.remaining_amount) : '-'}</span>
                              </div>
                            </>
                          )}
                        </td>
                        <td className="col-status text-center">
                          {item.submit_for_approval === false ? (
                            <span style={{ fontSize: '11px', color: '#94a3b8' }}>Expense Not Submitted</span>
                          ) : (
                            <ViewDynamicApprovalStatus dynamic_approval={item.dynamic_approval} />
                          )}
                        </td>
                        <td className="col-action text-center">
                          <div className="action-group-minimal" style={{ justifyContent: 'center', flexDirection: 'column' }}>
                            {item.submit_for_approval === false ? (
                              <div>
                                {item.imprest_data?.dynamic_approval?.some(da => da.approval_status === "rejected") ? (
                                  <span style={{ fontSize: '11px', color: '#ef4444' }} title={`Reason: ${item.account_rejection_reason}`}>Imprest Rejected</span>
                                ) : item.imprest_data?.dynamic_approval?.some(da => da.approval_status === "pending") ? (
                                  <span style={{ fontSize: '11px', color: '#f59e0b' }}>Imprest Pending</span>
                                ) : item.imprest_data?.dynamic_approval?.every(da => da.approval_status === "approved") ? (
                                  <ExpenseSubmit
                                    getExpansee={getExpansee}
                                    i={item}
                                    total={
                                      Number(item.imprest_data?.approved_stationary_item) +
                                      Number(item.imprest_data?.approved_electronic_item) +
                                      Number(item.imprest_data?.approved_project_imprest_monthly) +
                                      Number(item.imprest_data?.approved_grocery) +
                                      (item.imprest_data?.other_details?.length > 0
                                        ? item.imprest_data?.other_details.reduce((total, other) => total + Number(other.approved_other || 0), 0)
                                        : 0)
                                    }
                                  />
                                ) : (
                                  <span style={{ fontSize: '11px' }}>Finalizing: {item.imprest_data?.dynamic_approval?.find(da => da.permissions === "Finalize")?.approval_status || "unknown"}</span>
                                )}
                                <ExpenseModelDelete getExpansee={getExpansee} id={item} />
                              </div>
                            ) : item.partially_change ? (
                              <div>
                                <span style={{ fontSize: '11px', color: '#ef4444' }}>Update Bills</span>
                                <ExpensePartialSubmit
                                  getExpansee={getExpansee}
                                  i={item}
                                  total={
                                    Number(item.imprest_data?.approved_stationary_item) +
                                    Number(item.imprest_data?.approved_electronic_item) +
                                    Number(item.imprest_data?.approved_grocery) +
                                    (item.imprest_data?.other_details?.length > 0
                                      ? item.imprest_data?.other_details.reduce((total, other) => total + Number(other.approved_other || 0), 0)
                                      : 0)
                                  }
                                />
                              </div>
                            ) : !item.imprest_data?.dynamic_approval?.every(da => da.approval_status === "approved") ? (
                              <span style={{ fontSize: '11px', color: '#f59e0b' }}>In Process...</span>
                            ) : (
                              <div style={{ fontSize: '11px', color: '#059669', textAlign: 'center' }}>
                                Completed
                                {item.settlement && item.settlement_bill && (
                                  <><br /><a href={item.settlement_bill} target="blank" style={{ color: '#059669', fontWeight: 600 }}>View</a></>
                                )}
                              </div>
                            )}
                          </div>
                        </td>
                      </tr>

                      {isExpanded && (
                        <tr className="expanded-row">
                          <td colSpan={6}>
                            <div className="expanded-content-attractive">
                              <div className="expanded-content-header">
                                <div className="expanded-content-title">
                                  <Sparkles size={13} />
                                  <span>Expense Details</span>
                                </div>
                              </div>

                              <div style={{ display: 'flex', gap: '14px', flexWrap: 'wrap', marginBottom: '14px' }}>
                                <div className="stage-card submitted" style={{ flex: 1, minWidth: '260px' }}>
                                  <div className="stage-header">
                                    <IndianRupee size={14} />
                                    <span>Approved Breakdown</span>
                                  </div>
                                  <div className="stage-content">
                                    {[
                                      { name: 'Approved Stationary', value: item.imprest_data?.approved_stationary_item },
                                      { name: 'Approved Project Imprest', value: item.imprest_data?.approved_project_imprest_monthly },
                                      { name: 'Approved Electronics', value: item.imprest_data?.approved_electronic_item },
                                      { name: 'Approved Grocery', value: item.imprest_data?.approved_grocery }
                                    ].map(({ name, value }) => (
                                      <div className="stage-row" key={name}><span className="stage-label">{name}</span><span className="amount">₹{formatCurrencyIndian(value)}</span></div>
                                    ))}
                                    {item.imprest_data?.other_details?.map((other, idx) => (
                                      <div className="stage-row" key={other.other_name || `other-${idx}`}>
                                        <span className="stage-label">{other.other_name || `Other-${idx + 1}`}</span>
                                        <span className="amount">₹{formatCurrencyIndian(other.approved_other || 0)}</span>
                                      </div>
                                    ))}
                                    <div className="stage-row" style={{ fontWeight: 700 }}><span className="stage-label">Total</span><span className="amount">₹{formatCurrencyIndian(totalApprovedAmount)}</span></div>
                                  </div>
                                </div>

                                <div className="stage-card approved" style={{ flex: 1, minWidth: '200px' }}>
                                  <div className="stage-header">
                                    <Wallet size={14} />
                                    <span>Actions</span>
                                  </div>
                                  <div className="stage-content">
                                    <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                                      {item.imprest_data?.dynamic_approval?.some((a) => a.permissions === "Finalize" && a.approval_status === "approved") ? (
                                        <ExpenseDetailsAdd
                                          i={item}
                                          expansee={getExpansee}
                                          totall={totalApprovedAmount}
                                          utilize={item.utilized_amount}
                                          remain={item.remaining_amount}
                                        />
                                      ) : (
                                        <span style={{ fontSize: '11px', color: '#f59e0b' }}>Imprest Approval Pending</span>
                                      )}
                                      <button className="action-icon" onClick={() => openExenseSlip(item)} title="View">
                                        <Eye size={16} />
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <div className="stage-card" style={{ background: 'white' }}>
                                <div className="stage-header">
                                  <FileText size={14} />
                                  <span>Remarks</span>
                                </div>
                                <div className="stage-content">
                                  <ViewDynamicApprovalRemarks dynamic_approval={item.dynamic_approval} />
                                </div>
                              </div>
                            </div>
                          </td>
                        </tr>
                      )}
                    </React.Fragment>
                  );
                })}
                {expansee.length === 0 && (
                  <tr>
                    <td colSpan={6}>
                      <div className="empty-state-attractive">
                        <div className="empty-state-icon-wrap"><Receipt size={32} /></div>
                        <h4 className="empty-state-title">No Expenses Found</h4>
                        <p className="empty-state-subtitle">No expense records have been submitted yet.</p>
                      </div>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          )}
        </div>
      )}

      {/* Tab 3 Table: Imprest Details */}
      {toggleState === 3 && (
        <div className="table-wrapper-minimal table-box scroll-container-table">
          {buffer ? (
            <div className="loader-minimal"><div className="spinner-minimal"></div></div>
          ) : (
            <table className="progress-table-minimal">
              <thead className="table-heading">
                <tr>
                  <th className="col-sno" style={{ width: '5%' }}>#</th>
                  <th className="col-period" style={{ width: '20%' }}>Project</th>
                  <th className="col-period text-center">Bank Details</th>
                  <th className="col-submitted text-center" style={{ width: '15%' }}>Fixed Imprest Amt.</th>
                  <th className="col-action text-center" style={{ width: '12%' }}>Action</th>
                </tr>
              </thead>
              <tbody>
                {imprestDetails.map((item, index) => (
                  <tr className="progress-row" key={index}>
                    <td className="col-sno text-start">{index + 1}.</td>
                    <td className="col-period">
                      {item.siteproject_prcode}<br />{item.siteproject_name}
                    </td>
                    <td className="col-period">
                      <button className="period-trigger" style={{ width: "100%" }} onClick={() => toggleDetailRow(index)}>
                        <Landmark size={12} />
                        <span>{item.bank_name || "-"}</span>
                        {expandedDetailRow === index ? <ChevronUp size={12} /> : <ChevronDown size={12} />}
                      </button>
                      {expandedDetailRow === index && (
                        <div style={{ marginTop: '8px', padding: '10px', background: '#f8fafc', borderRadius: '8px', fontSize: '11px' }}>
                          <div className="stage-row"><span className="stage-label">Account Number</span><span className="amount">{item.account_number || "-"}</span></div>
                          <div className="stage-row"><span className="stage-label">IFSC Code</span><span className="amount">{item.ifsc_code || "-"}</span></div>
                          <div className="stage-row"><span className="stage-label">PAN No.</span><span className="amount">{item.pan_card || "-"}</span></div>
                          <div className="stage-row"><span className="stage-label">Holder Name</span><span className="amount">{item.account_holder_name || "-"}</span></div>
                          <div className="stage-row"><span className="stage-label">Phone No.</span><span className="amount">{item.phone_number || "-"}</span></div>
                          <div className="stage-row"><span className="stage-label">Total Staff</span><span className="amount">{item.total_number_officesite || "-"}</span></div>
                        </div>
                      )}
                    </td>
                    <td className="col-submitted text-center">
                      <span className="badge-value">{item?.fixed_imprest_amount ? `₹${formatCurrencyIndian(item.fixed_imprest_amount)}` : "-"}</span>
                    </td>
                    <td className="col-action text-center">
                      <div className="action-group-minimal" style={{ justifyContent: 'center' }}>
                        <AddUpdateImprestDetails getData={getImprestDetails} usedfor="Edit" i={item} />
                        <DeleteImprestDetails getData={getImprestDetails} i={item} />
                      </div>
                    </td>
                  </tr>
                ))}
                {imprestDetails.length === 0 && (
                  <tr>
                    <td colSpan={5}>
                      <div className="empty-state-attractive">
                        <div className="empty-state-icon-wrap"><Landmark size={32} /></div>
                        <h4 className="empty-state-title">No Imprest Details Found</h4>
                        <p className="empty-state-subtitle">No project imprest details have been added yet.</p>
                      </div>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          )}
        </div>
      )}
    </div>
  );
};

export default Expenses;
